<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-12">
        <app-breadcrumb
          :page-title="$t('package_details')"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
      <!-- <div class="content-wrapper">
        <span
          >You currently have no packages selected. Please select one of the
          below to continue using the portal.</span
        >
      </div> -->
      <div class="col-sm-12 col-md-12">
         <!--<app-table
                :id="tableId"
                :options="options"
                @action="getListAction"
            />-->
         <button class="btn btn-info float-right mb-3" @click="back">Back To Packages</button>
      </div> 
    </div>
    <div class="card card-shadow px-2">
        <form-accordiant :data="formData"></form-accordiant> 
    </div>
     
  </div>
</template>

<script>
import FormAccordiant  from "./FormAccordiant";
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../Config/ApiUrl";
import { TableHelpers } from "../../Demo/Tables/mixins/TableHelpers";
import AppFunction from "../../../../../core/helpers/app/AppFunction";
import { axiosGet } from "../../../../Helpers/AxiosHelper.js";

export default {
 components:{FormAccordiant},
  extends: CoreLibrary,
  name: "DatatableWithFilter",
  mixins: [TableHelpers],
  data() {
    return {
      formData:[],
      packages: {},
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      tableId: "advance-table",
      rowData: {},
      options: {
        name: "AdvanceTable",
        url: actions.PACKAGE_DETAIL_LIST,
        showHeader: true,
        columns: [
          {
            title: this.$t("title"),
            type: "custom-html",
            key: "assigned_package_form",
            modifier: (value) => {
              return `<span>${this.$t(value[0].title)}</span>`;
            },
          },
          {
            title: this.$t("period"),
            type: "custom-html",
            key: "period",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
        ],
        actions: [
          // {
          //   title: this.$t("edit"),
          //   icon: "edit",
          //   type: "none",
          //   component: "app-add-modal",
          //   modalId: "demo-add-edit-Modal",
          // },
          // {
          //   title: this.$t("delete"),
          //   icon: "trash",
          //   type: "none",
          //   component: "app-confirmation-modal",
          //   modalId: "demo-delete",
          // },
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
          },
        ],
        filters: [
          // {
          //     "title": this.$t('date'),
          //     "type": "range-picker",
          //     "key": "date",
          //     "option": ["today", "thisMonth", "last7Days", "nextYear"]
          // },
          // {
          //     "title": this.$t('age'),
          //     "type": "range-filter",
          //     "key": "age-range",
          //     "maxTitle": this.$t('max_age'),
          //     "minTitle": this.$t('min_age'),
          //     "sign": ""
          // },
          // {
          //     "title": this.$t('status'),
          //     "type": "checkbox",
          //     "key": "status",
          //     "option": [
          //         {id: 'active', value: 'Active'},
          //         {id: 'inactive', value: 'Inactive'},
          //         {id: 'invited', value: 'Invited'},
          //     ],
          // },
          // {
          //     "title": this.$t('gender'),
          //     "type": "radio",
          //     "key": "filter-with-gender",
          //     "option": [
          //         {id: 'male', value: 'Male'},
          //         {id: 'female', value: 'Female'},
          //         {id: 'other', value: 'Other'},
          //     ],
          //     "header": {
          //         "title": this.$t('want_to_filter_your_list'),
          //         "description": this.$t('you_can_filter_your_data_table_which_are_created_based_on_gender'),
          //     },
          // },
          // {
          //     "title": this.$t('search_and_select'),
          //     "type": "drop-down-filter",
          //     "key": "search select",
          //     "option": [],
          // }
        ],
        showFilter: false,
        showSearch: false,
        showCount: false,
        showClearFilter: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    this.searchAndSelectFilterOptions();
  },
  methods: {
    /**
     * for open add edit modal
     */
    back() {
        window.location = '/admin/packages/view';

    },
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    /**
     * for close add edit modal
     */
    closeAddEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
      this.searchAndSelectFilterOptions();
      this.reSetData();
    },

    /**
     * $emit Form datatable action
     */
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == "View") {
        alert(rowData.assigned_package_form[0].id);
      }
    },

    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    /**
     * confirmed $emit Form confirmation modal
     */
    confirmed() {
      let url = `${actions.PACKAGE_DISTROY}/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosGet(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#demo-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(response.data.message);
          this.searchAndSelectFilterOptions();
        })
        .catch(({ error }) => {
          // Trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    /**
     * cancelled $emit Form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },
    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    searchAndSelectFilterOptions() {
      this.axiosGet(actions.DATATABLE_SEARCH_SELECT).then((response) => {
        let name = this.options.filters.find(
          (element) => element.title === this.$t("search_and_select")
        );

        name.option = response.data.map((name) => {
          return {
            id: name.name,
            value: name.name,
          };
        });
      });
    },
    getPackages() {
      axiosGet(actions.PACKAGE_LISTING)
        .then((res) => {
          this.packages = res.data.data;
        })
        .catch((error) => {
          
        });
    },
    btnSubmit(id) {
      location.replace("/admin/stripePay/" + id);
    },

    getAssignForm() {
        let myLocation = location.href;
        let split = myLocation.split("/");
        let id = split[6].split("?")[0];
        axiosGet(actions.PACKAGE_DETAIL_LIST+'/'+id)
            .then((res) => {
            // this.document = res.data;
            
            this.formData = res.data;
            
            })
            .catch((error) => {
            
            });
    },
  },
  mounted() {
    this.getAssignForm();
  },
};
</script>
